<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.created_at"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <b-form-input v-model="ajaxSearch.attempt_login"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_password')}}</template>
                        <b-form-input v-model="ajaxSearch.attempt_password"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">IP</template>
                        <b-form-input v-model="ajaxSearch.last_ip"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" @click="initialize()">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </b-card>
                <b-card :header="$t($route.name)" class="mt-3">
                    <el-table class="custom-table" :data="ajaxTable" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import {securityAjaxTable} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader','reload'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxRow:'',     
            ajaxSearch:{limit:'',pagination:'',created_at:'',id:'',remark:'',attempt_login:'',attempt_password:'',last_ip:''},
            searchType:'',
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'70'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'140'
            },{
                prop: "attempt_login",
                label: this.$t('admin.table_username'),
                width:'169'                
            },{
                prop: "attempt_password",
                label: this.$t('admin.table_password'),
                width:'169'                
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'169'
            },{
                prop: "last_ip",
                label: "IP",
                width:'169'                              
            }] 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = securityAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.created_at,this.ajaxSearch.id,this.ajaxSearch.remark,this.ajaxSearch.attempt_login,this.ajaxSearch.attempt_password,this.ajaxSearch.last_ip);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
            this.ajaxUrl = row.url;
            this.showEdit = false;
            if(row.status == 1){
                this.showEdit = true;
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
